<ion-content class="m-modal">
  <ion-grid class="ion-padding">
    <ion-row class="m-modal-header">
      <ion-col size="12" size-md="11">
        <h4 class="m-modal-title">{{ modalTitle }}</h4>
      </ion-col>
      <ion-col size="6" size-md="1" class="ion-text-center">
        <ion-button color="tech-blue" class="m-modal-icon" fill="clear" (click)="dismiss()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="m-modal-body">
      <ion-col size="12">

        <ion-list class="m-modal-field-list list-color-custom list-padding-custom">
          @if(tableFinanceDetail.length > 0) {
          <ion-grid class="ion-no-padding">
            <ion-row class="ion-align-items-center ion-justify-content-end">
              <ion-col size="auto" class="ion-no-padding">
                <ion-button expand="block" size="small" fill="clear" color="stone-gray" class="bar-btn-custom no-ripple"
                  (click)="onParseDataToExcelFile('Financial')" matTooltip="Exportar Financial">
                  <ion-icon slot="start" [src]="'/assets/imgs/icons/export-table.svg'"
                      class="icon-color-custom-svg ion-icon-svg-export-table"></ion-icon>
                  {{ 'Boton._Exportar' | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
          @if(modalType === 'Complete') {
          <h4 class="m-modal-subtitle-financial">Financial</h4>
          }
          <p class="table-container table-margin-custom" [innerHTML]="tableFinanceDetail"></p>
          }

          @if(tableOperationsDetail.length > 0) {
          <ion-grid class="ion-no-padding">
            <ion-row class="ion-align-items-center ion-justify-content-end">
              <ion-col size="auto" class="ion-no-padding">
                <ion-button expand="block" size="small" fill="clear" color="stone-gray" class="bar-btn-custom no-ripple"
                  (click)="onParseDataToExcelFile('Operations')" matTooltip="Exportar Operations">
                  <ion-icon slot="start" [src]="'/assets/imgs/icons/export-table.svg'"
                      class="icon-color-custom-svg ion-icon-svg-export-table"></ion-icon>
                  {{ 'Boton._Exportar' | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
          @if(modalType === 'Complete') {
          <h4 class="m-modal-subtitle-operations">Operations</h4>
          }
          <p class="table-container table-margin-custom" [innerHTML]="tableOperationsDetail"></p>
          }
        </ion-list>

      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>